@if (authStatus() === true && !isTabletSession()) {
  <div class="layout">
    <o3-core-app-topbar
      class="layout-topbar"
      (toggleSidebar)="toggleSidebar()"
      (toggleNotificationsbar)="toggleNotificationsbar()"
    ></o3-core-app-topbar>
    <div class="layout-container">
      <o3-core-app-sidebar
        class="layout-sidebar"
        [isSidebarCollapsed]="isSidebarCollapsed"
      ></o3-core-app-sidebar>
      <div
        class="layout-body"
        [ngClass]="{
          'layout-body-sidebar-collapsed': isSidebarCollapsed,
          'layout-body-notifications-bar-collapsed':
            isNotificationsbarCollapsed,
        }"
      >
        <router-outlet></router-outlet>
      </div>
      <o3-core-app-notifications-bar
        class="layout-notifications"
        [isNotificationsbarCollapsed]="isNotificationsbarCollapsed"
      ></o3-core-app-notifications-bar>
    </div>
  </div>

  <!-- Global Messaging Overlay (floating chats + notification toasts) -->
  <o3-communication-messaging-overlay />
} @else {
  <router-outlet></router-outlet>
}
